import { Component, OnInit, Input } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../../../app.config';
import { MessageService } from 'primeng/api';
import { RegistrationService } from '../../../../services/registration.service';
import { CountriesService } from '../../../../services/countries.service';
import { AuthenticationService, HelpersService } from '../../../../services';
import { take } from 'rxjs';

@Component({
  selector: 'app-wizard-registration',
  templateUrl: './wizard-registration.component.html',
  styleUrls: ['./wizard-registration.component.scss'],
})
export class WizardRegistrationComponent implements OnInit {
  @Input() messageService: MessageService;
  @Input() country;

  public RegistrationForm: FormGroup;
  public units: any = this.appConfig.getUnits();
  public countries = []; //this.appConfig.getSupportedCountries();
  public registered = false;
  public registering = false;
  public message = null;
  public partnerTypes: any = [];

  public domains = [];
  public isInvalidDomain = false;


  constructor(
    private appConfig: AppConfig,
    private fb: FormBuilder,
    private translate: TranslateService,
    private registrationService: RegistrationService,
    private countriesService: CountriesService,
    private authenticationService: AuthenticationService,
    private helpers: HelpersService,
  ) {}

  ngOnInit() {
    this.partnerTypes = this.appConfig.getPartnerTypes().sort((x, y) => {
      if (x.label < y.label) return -1;
      if (x.label > y.label) return 1;
      return 0;
    });
    this.loadDomains();
    this.setupValidation();
    this.countriesService.getAllCountries().subscribe((countries) => {
      this.countries = countries.map((x) => {
        return { ...x, label: x.country, value: x.code };
      });
    });

    this.getCountryFromIP();
  }

  setupValidation() {
    this.RegistrationForm = this.fb.group({
      BikeShopName: new FormControl('', Validators.required),
      Email: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
      ]),
      CustomerName: new FormControl('', Validators.required),
      Country: new FormControl('', Validators.required),
      PhoneNumber: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9+()\\-\\s]+$'), // allows digits, +, (, ), -, and spaces
          Validators.minLength(7), // adjust to your required length
        ]),
      ),
      Workshop: new FormControl(false, Validators.required),
      Rentals: new FormControl(false, Validators.required),
      PartnerType: new FormControl(1, Validators.required),
    });
  }

  onCountrySelected() {
    var country = this.countries.filter((country) => {
      return country.value === this.RegistrationForm.value.Country.code;
    })[0];
    this.RegistrationForm.controls['PhoneNumber'].setValue(country.countryCode);
  }

  registerShop() {
    if (!this.RegistrationForm.valid) {
      this.RegistrationForm.markAllAsTouched();
      return false;
    }

    if (!this.validDomain()) return false;

    this.registering = true;
    this.message = null;

    var value = this.RegistrationForm.value;
    var Name = value.CustomerName.substr(0, value.CustomerName.indexOf(' '));
    var Surname = value.CustomerName.substr(
      value.CustomerName.indexOf(' ') + 1,
    );
    let country = this.RegistrationForm.value.Country;

    var registration = {
      BikeShopName: value.BikeShopName,
      CurrencyCode: country.currency,
      CurrencySymbol: country.currencySymbol,
      Phone: value.PhoneNumber,
      Email: value.Email,
      Name: Name,
      Surname: Surname,
      Country: value.Country.code,
      VatRate: country.taxRate,
      VatInclusive: country.taxInclusive,
      UnitOfMeasure: country.unitOfMeasure,
      Workshop: value.Workshop,
      Rentals: value.Rentals,
      PartnerType: value.PartnerType,
      SignUpCountry: this.country,
    };

    this.registrationService.registerBikeshop(registration).subscribe(
      (result) => {
        this.registering = false;
        this.registered = true;
        this.message = this.translate.instant(
          'onboarding.messages.step_one_complete',
          { email: this.RegistrationForm.value.Email },
        );

        try {
          window['dataLayer'] = window['dataLayer'] || [];
          window['dataLayer'].push({
            event: 'free_trial_form_submitted'
          });
        } catch (e) {}

        //this.messageService.add({ detail: this.message });
      },
      (err) => {
        this.registered = false;
        this.registering = false;
        this.message = this.translate.instant(
          'onboarding.messages.step_one_error',
          { error: err && err.Message ? err.Message : '' },
        );
        this.messageService.add({ detail: this.message });
      },
    );
  }

  loadDomains() {
    this.authenticationService.getInvalidDomains().subscribe((res) => {
      this.domains = res;
    });
  }

  validDomain() {
    this.message = '';
    if (this.domains.length > 0) {
      var email = this.RegistrationForm.value.Email;
      if (email && email.length > 0 && email.indexOf('@') > -1) {
        if (
          this.domains.indexOf(email.substring(email.indexOf('@') + 1)) > -1
        ) {
          this.message = 'Invalid domain';
          this.messageService.add({ detail: this.message });
          this.isInvalidDomain = true;
          return false;
        } else {
          this.isInvalidDomain = false;
          return true;
        }
      }
    } else {
      this.isInvalidDomain = false;
      return true;
    }
  }

  productSelected() {
    return (
      this.RegistrationForm.value.Workshop ||
      this.RegistrationForm.value.Rentals
    );
  }

  getCountryFromIP() {
    this.helpers.getCountryFromIP().subscribe((res: any) => {
      let selectedCountry = this.countries.find(
        (country) => country.code == res.country_code,
      );
      this.RegistrationForm.controls['Country'].setValue(selectedCountry);
      setTimeout(() => this.InitCountrySelected(), 1000);
    });
  }

  InitCountrySelected() {
    var country = this.countries.filter((country) => {
      return country.value === this.RegistrationForm.value.Country.code;
    })[0];
    if (country && country.countryCode) {
      this.RegistrationForm.controls['PhoneNumber'].setValue(
        country.countryCode,
      );
    }
  }
}
